import { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const TOPBAR_SLOT_ID = 'yd-topbar-actions';

/**
 * Renders page-level top-bar controls (section picker, primary action) into the shell's top bar.
 *
 * The slot is `display: contents` and sits before the theme toggle and the alerts bell, so
 * children appear to their left. A page's orange primary action must carry className
 * "order-last" so it lands after the bell, as in the design.
 */
export default function TopBarActions({ children }: { children: ReactNode }) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  useEffect(() => { setSlot(document.getElementById(TOPBAR_SLOT_ID)); }, []);
  return slot ? createPortal(children, slot) : null;
}
